<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/luQTiW/tc-custom/9781626810976.jpg?1703734223051" alt="This image is the cover for the book Sword of the Lamb, The Phoenix Legacy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sword of the Lamb, The Phoenix Legacy
      </h1>
      <p class="bookDescription body article font2">
        <b>The thrilling start to the Phoenix Legacy space opera: “A new classic! Has the sweep and power of Asimov’s Foundation Trilogy” (Jean M. Auel, author of the </b><b>Earth’s Children series).</b><br/>  <br/> At the heart of the Concord empire, unrest is festering. Unrecognized by the Elite, the ruling class, an undercurrent of rebellion is surging through the enslaved Bond class. It’s a threat that could bring down all of civilization, creating a third Dark Age.<br/>  <br/> Lord Alexand, first born of the House of DeKoven Woolf, stands to inherit a vast industrial conglomerate along with a seat on the Directorate, the Concord’s ruling body. But he sees the writing on the wall and realizes that if the Bonds explode into total rebellion, there will be nothing to inherit, and the toll in human suffering will be beyond calculation. He makes the difficult decision to “die” and join the Society of the Phoenix, a clandestine organization whose existence is known to only a few Directorate Lords, who consider membership treason and punishable by death. But it may be humanity’s only hope . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        M.K. Wren
      </h2>
      
      <p class="authorDescription body article">Martha Kay Renfroe is an Oregon writer, author of mystery and science fiction under the pen name M.K. Wren. Her work includes the Conan Flagg&#160;mystery series, the Phoenix Legacy&#160;trilogy, and the post-apocalyptic novel&#160;<I>A Gift Upon the Shore</I>, set along the Oregon coast.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6ee0cde6